import { Component, input, output, inject } from '@angular/core';
import { UserManagerService } from '../../services/user-manager/user-manager.service';
import { toSignal } from '@angular/core/rxjs-interop';


@Component({
    selector: 'dish-auth-header-buttons',
    templateUrl: './auth-header-buttons.component.html',
    styleUrls: ['./auth-header-buttons.component.scss'],
    imports: []
})
export class AuthHeaderButtonsComponent {
  readonly registrationCode = input<string | null>(null);
  readonly currentUrl = input('');

  private readonly userManagerService = inject(UserManagerService)

  userLoggedIn = toSignal(this.userManagerService.currentUserLoggedIn$);

  userLoggedOut = output<boolean>();

  logout() {
    this.userManagerService.logOut();
    this.userManagerService.setUserLoggedOut();
    this.userLoggedOut.emit(true);
  }
}
